import { OrderedMap, Record } from 'immutable';
import {
  LESSON_BORDER_COLOR,
  DANGER_TITLE_COLOR,
  DANGER_BACKGROUND_COLOR,
  RED_F as TITLE_BORDER_RED_COLOR,
  INFO_TITLE_COLOR,
  INFO_BACKGROUND_COLOR,
  BLUE_E as TITLE_BORDER_BLUE_COLOR,
  SUCCESS_TITLE_COLOR,
  SUCCESS_BACKGROUND_COLOR,
  GREEN_G as TITLE_BORDER_GREEN_COLOR,
} from 'app/constants/Colors';
import { getNameFunctionType } from 'app/services/localization';

const blueColors = {
  title: INFO_TITLE_COLOR,
  titleBorder: TITLE_BORDER_BLUE_COLOR,
  background: INFO_BACKGROUND_COLOR,
};

export type ExerciseTypeId = 'Standard' | 'Explanation' | 'TeacherNote' | 'Aside' | 'Attribution';

export interface IExerciseType {
  id: ExerciseTypeId;
  getName: getNameFunctionType;
  colors: {
    title: string;
    titleBorder: string;
    background: string;
  };
}

export const ExerciseType = Record<IExerciseType>(
  {
    id: 'Standard',
    getName: t => '',
    colors: {
      title: '',
      titleBorder: '',
      background: '',
    },
  },
  'ExerciseType',
);

export const STANDARD = new ExerciseType({
  id: 'Standard',
  getName: t => t('admin.editor.exercise-type.standard'),
  colors: {
    title: 'black',
    titleBorder: LESSON_BORDER_COLOR,
    background: 'white',
  },
});
export const EXPLANATION = new ExerciseType({
  id: 'Explanation',
  getName: t => t('admin.editor.exercise-type.explanation'),
  colors: blueColors,
});
export const TEACHER_NOTE = new ExerciseType({
  id: 'TeacherNote',
  getName: t => t('admin.editor.exercise-type.teacher-note'),
  colors: {
    title: DANGER_TITLE_COLOR,
    titleBorder: TITLE_BORDER_RED_COLOR,
    background: DANGER_BACKGROUND_COLOR,
  },
});
export const ASIDE = new ExerciseType({
  id: 'Aside',
  getName: t => t('admin.editor.exercise-type.aside'),
  colors: {
    title: SUCCESS_TITLE_COLOR,
    titleBorder: TITLE_BORDER_GREEN_COLOR,
    background: SUCCESS_BACKGROUND_COLOR,
  },
});
export const ATTRIBUTION = new ExerciseType({
  id: 'Attribution',
  getName: t => t('admin.editor.exercise-type.attribution'),
  colors: blueColors,
});

const EXERCISE_TYPES = OrderedMap([
  [STANDARD.id, STANDARD],
  [EXPLANATION.id, EXPLANATION],
  [TEACHER_NOTE.id, TEACHER_NOTE],
  [ASIDE.id, ASIDE],
  [ATTRIBUTION.id, ATTRIBUTION],
]);

export default EXERCISE_TYPES;
